/********************************************
 * Featured Projects
*
********************************************/
function fnProjectsArchive( i, oSection ) {


	/*****************
	* Objects
	*****************/
	var oSection				= $( oSection ),
		oHeaderNav				= $(oSection, 'nav.filters-area');
		


	oHeaderNav.on('click',function(){
		var oBtn = $('a.filters-mobile-new',this);

		oBtn.on("click",function(e){
			var oArea = $('.toggle-area',oHeaderNav);
			oArea.stop().slideToggle();

			// if(oArea.is(":visible")){
   //              oArea.hide();
   //          } else{
   //              oArea.show();
   //          }
		});
	});

}


// END OF DOCUMENT
